import { ReactComponent as GithubIcon } from "../../../../assets/github-logo.svg";
import { ReactComponent as TwitterIcon } from "../../../../assets/twitter-logo.svg";
import { ReactComponent as EthereumIcon } from "common/src/assets/ethereum-icon.svg";
import { ReactComponent as GlobeIcon } from "../../../../assets/icons/globe-icon.svg";
import { formatDateWithOrdinal, useValidateCredential } from "common";
import { useEnsName } from "wagmi";
import { ProjectLink } from "./ProjectLink";
import CopyToClipboard from "common/src/components/CopyToClipboard";
import { CalendarIcon } from "./CalendarIcon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProjectLinks(_ref) {
  let {
    project
  } = _ref;
  const {
    recipient,
    projectMetadata: {
      createdAt,
      website,
      projectTwitter,
      projectGithub,
      userGithub,
      credentials
    }
  } = project !== null && project !== void 0 ? project : {
    projectMetadata: {}
  };

  // @ts-expect-error Temp until viem (could also cast recipient as Address or update the type)
  const ens = useEnsName({
    address: recipient,
    enabled: Boolean(recipient)
  });
  const {
    isValid: validTwitterCredential
  } = useValidateCredential(credentials === null || credentials === void 0 ? void 0 : credentials.twitter, projectTwitter);
  const {
    isValid: validGithubCredential
  } = useValidateCredential(credentials === null || credentials === void 0 ? void 0 : credentials.github, projectGithub);
  const createdOn = createdAt && `Created on: ${formatDateWithOrdinal(new Date(createdAt !== null && createdAt !== void 0 ? createdAt : 0))}`;
  return /*#__PURE__*/_jsxs("div", {
    className: `grid md:grid-cols-2 gap-4  border-y-[2px] py-4 my-4 ${
    // isLoading?
    createdAt ? "" : "bg-grey-100 animate-pulse"}`,
    children: [/*#__PURE__*/_jsx(ProjectLink, {
      icon: EthereumIcon,
      children: /*#__PURE__*/_jsx(CopyToClipboard, {
        text: ens.data || recipient
      })
    }), /*#__PURE__*/_jsx(ProjectLink, {
      icon: CalendarIcon,
      children: createdOn
    }), /*#__PURE__*/_jsx(ProjectLink, {
      url: website,
      icon: GlobeIcon,
      children: website
    }), projectTwitter !== undefined && /*#__PURE__*/_jsx(ProjectLink, {
      url: `https://twitter.com/${projectTwitter}`,
      icon: TwitterIcon,
      isVerified: validTwitterCredential,
      children: projectTwitter
    }), projectGithub !== undefined && /*#__PURE__*/_jsx(ProjectLink, {
      url: `https://github.com/${projectGithub}`,
      icon: GithubIcon,
      isVerified: validGithubCredential,
      children: projectGithub
    }), userGithub !== undefined && /*#__PURE__*/_jsx(ProjectLink, {
      url: `https://github.com/${userGithub}`,
      icon: GithubIcon,
      children: userGithub
    })]
  });
}